import { WhatsAppLogoSVG } from "./svg";

export default function WhatsAppButton({
  className = "",
  href = "",
  ...props
}) {
  const button = (
    <button
      {...props}
      className={`group bg-transparent text-lg text-white hover:text-gray-200 font-semibold ${className}`}
    >
      {props.children}
      <WhatsAppLogoSVG
        className={"ml-4 inline w-[32px] h-auto group-hover:fill-[#22BF5B]"}
      />
    </button>
  );
  return (
    <a href={href} target="_blank" rel="noreferrer" aria-label="WhatsApp Us">
      {button}
    </a>
  );
}
